import React from 'react';
import readRedIcon from '../../../../../assets/images/readRed.png';
import readIcon from '../../../../../assets/images/read.png';
import residentRedIcon from '../../../../../assets/images/residentRed.png';
import residentIcon from '../../../../../assets/images/resident.png';
import specialistRedIcon from '../../../../../assets/images/doctorRed.png';
import specialistIcon from '../../../../../assets/images/doctor.png';
import { Link } from 'react-router-dom';
import { getLang } from '../../../../../environnement';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';

function EventFormItem({
  title,
  icon,
  iconHovered,
  link,
  details
}) {
  return (
    <Link to={link}>
      <div className={`group mx-14 mb-10 sm:mb-16 flex flex-col items-center ${details ? 'sm:h-96' : 'xxs:h-96'} cursor-pointer`}>
        <div className={`rounded-full border border-primary w-40 h-40 ${details ? 'sm:w-60 sm:h-60' : 'xxs:w-60 xxs:h-60'} flex justify-center items-center group-hover:bg-primary`}>
          <img src={icon} alt='itemIcon' className='group-hover:hidden w-24 h-24'/>
          <img src={iconHovered} alt='itemIcon' className='hidden group-hover:inline w-24 h-24'/>
        </div>
        <p className={`font-medium text-primary text-center mt-5 ${details ? 'text-sm sm:text-xl' : 'text-xl'}`}>{title}</p>
      </div>
    </Link>
  );
}

export default function InscriptionAtelierForms({
  eventFormDiv,
  details=false
}) {
  const lang = useSelector(langSelector);

  return (
    <div ref={eventFormDiv} className='flex flex-col items-center'>
      <p className={`text-primary mx-10 xxs:mx-0 text-center my-10 ${details ? 'text-sm sm:text-3xl font-bold' : 'text-2xl xxs:text-3xl font-medium'}`}>Inscription aux ateliers</p>
      <div className='flex flex-col justify-center items-center pt-5 pb-10 lg:flex-row w-[90%]'>
        <EventFormItem details={details} icon={readRedIcon} iconHovered={readIcon} title='Etudiant' link='/inscriptionAtelierEtudiant' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <EventFormItem details={details} icon={residentRedIcon} iconHovered={residentIcon} title='Résident' link='/inscriptionAtelierResident' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <EventFormItem details={details} icon={specialistRedIcon} iconHovered={specialistIcon} title='Spécialiste' link='/inscriptionAtelierSpecialiste' />
      </div>
    </div>
  );
}
